<template>
    <div class="dt-previewCard__wrapperElements" v-if="element['@type'] === 'button'">

        <template v-if="element['action']['@type'] === 'open-card'">
            <router-link :to="item.getUrl()" :class="getClasses()">
                {{ element.title }}
            </router-link>
        </template>
        <template v-if="element['action']['@type'] === 'link'">
            <a :href="element['action']['value']" target="_blank" :class="getClasses()">
                {{ element.title }}
            </a>
        </template>
        <template v-if="element['action']['@type'] === 'script'">
            <button @click="executeScript(element['action']['script'])" :class="getClasses()">
                {{ element.title }}
            </button>
        </template>
    </div>
</template>
<script>
export default {
    props: [
        "element",
        "item",
        "buttonBlock"
    ],
    methods: {
        executeScript(script) {
            try {
                const func = new Function(script);
                func();
            } catch (err) {
                console.warn(script);
                console.warn(err);
            }
        },
        getClasses() {
            return {
                "button button-responsive": true,
                "button-block": this.buttonBlock === true,
                "button-xs": this.element.size === "small",
                "button-primary": this.element.style.viewMode === "default",
                "button-second": this.element.style.viewMode === "light",
            };
        },
    },
};
</script>
